<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor'
export default
{
    computed: mapGetters({ data: 'generalConfig' }),

    components: { VueEditor },

    methods:
    {
        save()
        {
            axios.post(process.env.API_URL + '/v1/admin/settings', this.data).then(res => {
                this.$store.dispatch('fetchSettings')
            })
        },

        addFile(key, file)
        {
            this.$set(this.data[key], 'value', file.display_url)
            this.$forceUpdate()
        },

        addRow(key)
        {
            if (!Array.isArray(this.data[key].value))
            {
                this.$set(this.data[key], 'value', [])
            }
            this.data[key].value.push(['', ''])
        },

        removeRow(key, index)
        {
            this.data[key].value.splice(index, 1)
        }
    },

    data() {
        return {
            editorSettings: {
                imageResize: {},
            },
        }
    }

}
</script>

<template>
    <div class="container-fluid">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-12">
                        <h4>Fő oldal</h4>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <form @submit.prevent.stop="save">
                    <div class="form-group row" v-for="(obj, key) in data" :key="key" v-if="key && key.includes('main_page_')">
                        <label class="col-md-4 control-label">
                            {{ $t('SETTINGS.' + key) }}
                        </label>
                        <div class="col-md-6">
                            <span v-if="obj.type == 'boolean'"></span>
                            <mv-date-time-picker v-if="obj.type == 'date'" v-model="data[key].value" />
                            <textarea class="form-control" v-else-if="obj.type == 'text'" type="text" v-model="data[key].value"></textarea>
                            <div v-else-if="obj.type == 'file'">
                                <img :src="data[key].value" style="width: 100%; max-width: 360px;">
                                <label class="btn btn-sm btn-primary">
                                  <mv-uploader ref="uploader" multiple @upload-done="addFile(key, $event)" accept="image/*" type="media"></mv-uploader>
                                  <icon name="file"></icon>
                                </label>
                            </div>
                            <vue-editor
                              :id="`editor-${key}`"
                              v-else-if="obj.type == 'html'"
                              :editorOptions="editorSettings"
                              v-model="data[key].value">
                            </vue-editor>
                            <div v-else-if="obj.type == 'array'">
                                <div class="row" style="margin-bottom: .5em;" v-for="(row, index) in data[key].value" :key="index">
                                    <div class="col-md-3">
                                        <input class="form-control" type="text" placeholder="Cím" v-model="row[0]">
                                    </div>
                                    <div class="col-md-4">
                                        <input class="form-control" type="text" placeholder="Szöveg" v-model="row[1]" v-if="row.length > 1">
                                    </div>
                                    <div class="col-md-4">
                                        <input class="form-control" type="text" placeholder="..." v-model="row[2]" v-if="row.length > 2">
                                    </div>
                                    <div class="col-md-1">
                                        <button class="btn btn-danger" @click.prevent.stop="removeRow(key, index)">
                                            <icon name="remove"></icon>
                                        </button>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-primary" @click.prevent.stop="addRow(key)">
                                    <icon name="plus"></icon> {{ $t('GENERAL.ADD') }}
                                </button>
                            </div>
                            <input class="form-control" v-else type="text" v-model="data[key].value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-12 text-right">
                            <button class="btn btn-success">{{ $t('GENERAL.SAVE') }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/MainPage.vue